import { XMarkIcon } from "@heroicons/react/24/outline";

import { RoboAdvisorIcon } from "ui/icon/features";

export const MobilePopoverHeader = ({ close }: { close: () => void }) => (
  <div className="flex items-center justify-between px-4 pb-5">
    <RoboAdvisorIcon width={30} height={30} className="shrink-0 fill-sky-700" />
    <XMarkIcon
      width={24}
      height={24}
      className="shrink-0 cursor-pointer text-zinc-400"
      onClick={close}
    />
  </div>
);
